import * as React from 'react';
import { ComplexValue, ValueProperty } from '../common/types';
import { toHex } from 'ui/common/hex-converter';
import styles from './badge.scss';
import { Tooltip, TooltipDirections } from 'ui/common/tooltip/tooltip';
import { Icon } from 'ui/common/icon';

export interface BadgeProps {
  title?: string;
  tooltip?: string;
  tooltipDirection?: TooltipDirections;
  showTooltip?: boolean;
  filled?: boolean;
  backgroundColor?: number;
  foregroundColor?: number;
  text?: ValueProperty;
  riskTrend?: ComplexValue<number>;
}

export class Badge extends React.PureComponent<BadgeProps> {
  public static defaultProps: Partial<BadgeProps> = {
    filled: true
  };

  public render() {
    const {
      title,
      filled,
      tooltip,
      tooltipDirection,
      text,
      backgroundColor,
      foregroundColor,
      showTooltip = true,
      riskTrend
    } = this.props;

    const fill = !!filled ? backgroundColor && toHex(backgroundColor) : 'transparent';
    const stroke = !!filled ? 'transparent' : !!backgroundColor && toHex(backgroundColor);
    const textFill = !!foregroundColor ? toHex(foregroundColor) : 'black';

    const iconTrend = !!riskTrend?.value ?
      <Icon key={new Date().getTime()} className={`${styles.iconRiskTrend}`} url={!!riskTrend?.icon && riskTrend?.icon} /> : undefined;
    const circleTooltip = showTooltip ? tooltip : '';
    const trendTooltip = showTooltip && riskTrend?.value ? '\n' + riskTrend?.description : '';
    const badgeTooltip = circleTooltip + trendTooltip;
    const circleInlineStyle = !!riskTrend?.value ? styles.circleWithRiskTrend : '';

    const circle = <svg className={`badge-illustration ${circleInlineStyle}`} viewBox="0 0 50 50" preserveAspectRatio="">
      <circle cx="25" cy="25" r="23" fill={fill} stroke={stroke} strokeWidth="4px" />
      <text className={styles.strong} x="25" y="32" fill={textFill} fontSize="22">{String(text)}</text>
    </svg>;

    return (
      <Tooltip className={styles.tooltipOverwrite} title={badgeTooltip} delayed={true} direction={tooltipDirection} narrow={true}
        center={true}>
        <div className={`${styles.badgeWrapper} badge-wrapper`}>
          {title && <label className={styles.label}>{title}</label>}
          <span className={styles.badgeContents}>
            {circle}
            {iconTrend}
          </span>
        </div>
      </Tooltip>
    );
  }
}
